import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-toolbox/lib/button';
import { connect } from 'react-redux';
import ComposeWindow from 'components/ComposeWindow';
import TextArea from 'components/TextArea';

import S from 'components/ComposeWindow/styles.scss';
import { addEventToPhase, updatePhase, clearValidation } from 'actionCreators/phase';
import PhaseType from 'types/phase';
import { getPhaseErrors } from '../../../../../../reducers';

class AddContractorNoteModal extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.active && !this.props.active) {
      this.setState({ note: nextProps.phase.contractor_notes });
    }
  }

  handleSubmit = () => {
    const phaseID = this.props.phase.id;
    const note = this.textAreaComponentRef.textAreaRef.value;

    const noteProps = {
      name: 'Contractor Note',
      kind: 'note',
      data: { note },
    };

    this.props.updatePhase(
      { id: phaseID, contractor_notes: note },
      { actionType: 'update_contractor_notes' },
    )
      .then(() =>
        this.props.addEventToPhase(phaseID, noteProps).then(() => {
          this.handleClose();
        }),
    )
    .catch(() => {}); // catching this to avoid console warnings...
  }

  handleClose = () => {
    this.props.clearValidation();
    this.props.onClose();
  }

  render() {
    const { active, errors } = this.props;

    return (
      <ComposeWindow
        active={active}
        title="Contractor Notes"
        onClose={this.handleClose}
      >
        <TextArea
          defaultValue={this.props.phase.contractor_notes}
          label="Notes *"
          className={S.compose}
          errors={errors.contractor_notes}
          autoFocus
          ref={(comp) => { this.textAreaComponentRef = comp; }}
        />
        <div className={S.actions}>
          <Button
            label="Save Note"
            primary flat ripple
            className={S.submit}
            onClick={this.handleSubmit}
          />
        </div>
      </ComposeWindow>
    );
  }
}

AddContractorNoteModal.propTypes = {
  active: PropTypes.bool.isRequired,
  updatePhase: PropTypes.func.isRequired,
  addEventToPhase: PropTypes.func.isRequired,
  clearValidation: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  phase: PhaseType.isRequired,
  errors: PropTypes.shape({
    contractor_notes: PropTypes.arrayOf(PropTypes.string),
  }),
};

AddContractorNoteModal.defaultProps = {
  active: false,
  errors: {},
};

export default connect(
  state => ({ errors: getPhaseErrors(state) }),
  { updatePhase, addEventToPhase, clearValidation },
)(AddContractorNoteModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/addContractorNoteModal.jsx